import React from "react";
import BackgroundColor from "views/components/backgroungColor/backgroundColor";
import TextEditor from "views/components/textEditor/textEditor";
import CardLaneV2 from "views/components/cardByLane/cardByLaneV2";
import CardCompacted from "views/components/cardByLane/cardCompacted";

import styles from "./styles.module.scss";

const playersPreview = [
  {
    activePlayer: false,
    active_player: false,
    game: 1,
    lane: 1,
    playerHcp: 0,
    playerName: "Player 1",
    playerNumber: 1,
    scoreCompletedGames: 0,
    teamHcp: 0,
    teamName: "",
    pins: [],
    scores: [18],
    speed: [],
    throws: ["6", "/", "X"],
  },
  {
    activePlayer: false,
    active_player: false,
    game: 1,
    lane: 2,
    playerHcp: 0,
    playerName: "Player 2",
    playerNumber: 2,
    scoreCompletedGames: 0,
    teamHcp: 0,
    teamName: "",
    pins: [],
    scores: [18],
    speed: [],
    throws: ["6", "/"],
  },
];
const playersMap = () => {
  const playersMap = new Map();
  playersPreview.forEach((player) => {
    playersMap.set(
      `${player.lane}:${player.playerNumber}:${player.playerName}`,
      player,
    );
  });
  return playersMap;
};

const ScorecardSettingsV2 = ({
  onChangeColor,
  onChangeFontSize,
  onChangeFontWeight,
  onChangeFontFamily,
  cardStyles,
  showCompactVersion,
}) => {
  const compactCardPlayers = playersMap();
  return (
    <div className={styles.bodyContainer}>
      <div className={styles.containerSettings}>
        <div className={styles.playerSettings}>
          <div className={styles.bodySettings}>
            <div className={styles.backgroundInputContainer}>
              <span>Section Container Background</span>
              <div className={styles.backgroundInput}>
                <BackgroundColor
                  handleChange={onChangeColor("section_container_background")}
                  background={cardStyles.section_container_background}
                  skew
                />
              </div>
            </div>

            <div className={styles.backgroundInputContainer}>
              <span>Scores Container Background</span>
              <div className={styles.backgroundInput}>
                <BackgroundColor
                  handleChange={onChangeColor("scores_container_background")}
                  background={cardStyles.scores_container_background}
                  skew
                />
              </div>
            </div>
            <div className={styles.backgroundInputContainer}>
              <span>Top Frame Background</span>
              <div className={styles.backgroundInput}>
                <BackgroundColor
                  handleChange={onChangeColor("top_frame_background")}
                  background={cardStyles["top_frame_background"]}
                  skew
                />
              </div>
            </div>
          </div>
          <div className={styles.bodySettings}>
            <TextEditor
              playerNameStyles={cardStyles.player_name}
              handleChangeComplete={onChangeColor("player_name.font_color")}
              handleChangeBackground={onChangeColor("player_name.background")}
              handleOnSelect={onChangeFontSize("player_name")}
              selectBold={onChangeFontWeight("player_name")}
              stylesLabel="Player Name Styles"
              fontWeight
              onChangeFontFamily={onChangeFontFamily("player_name")}
            />
            <TextEditor
              playerNameStyles={cardStyles.throws_style}
              handleChangeComplete={onChangeColor("throws_style.font_color")}
              handleChangeBackground={onChangeColor("throws_style.background")}
              handleOnSelect={onChangeFontSize("throws_style")}
              selectBold={onChangeFontWeight("throws_style")}
              stylesLabel="Throws"
              text="Throws"
              fontWeight
            />
            <TextEditor
              playerNameStyles={cardStyles.frame_score}
              handleChangeComplete={onChangeColor("frame_score.font_color")}
              handleChangeBackground={onChangeColor("frame_score.background")}
              handleOnSelect={onChangeFontSize("frame_score")}
              selectBold={onChangeFontWeight("frame_score")}
              stylesLabel="Throws Score"
              text="18"
              fontWeight
            />
            <TextEditor
              playerNameStyles={cardStyles.game_label}
              handleChangeComplete={onChangeColor("game_label.font_color")}
              handleChangeBackground={onChangeColor("frame_score.background")}
              handleOnSelect={onChangeFontSize("game_label")}
              selectBold={onChangeFontWeight("game_label")}
              stylesLabel="Game Label"
              text="Game 1"
              fontWeight
              onChangeFontFamily={onChangeFontFamily("game_label")}
            />
            <TextEditor
              playerNameStyles={cardStyles.total_score}
              handleChangeComplete={onChangeColor("total_score.color")}
              handleChangeBackground={onChangeColor(
                "total_score.background_color",
              )}
              handleOnSelect={onChangeFontSize("total_score")}
              selectBold={onChangeFontWeight("total_score")}
              stylesLabel="Total Score"
              text="300"
              fontWeight
              onChangeFontFamily={onChangeFontFamily("total_score")}
              background
              backgroundLabel="Total Score Background"
            />
            <TextEditor
              playerNameStyles={cardStyles.total_label}
              handleChangeComplete={onChangeColor("total_label.color")}
              handleChangeBackground={onChangeColor("total_label.background")}
              handleOnSelect={onChangeFontSize("total_label")}
              selectBold={onChangeFontWeight("total_label")}
              stylesLabel="Total Label"
              text="Total"
              fontWeight
              onChangeFontFamily={onChangeFontFamily("total_label")}
            />
          </div>
        </div>
        <div
          className={styles.playerSettings}
          style={{
            backgroundColor: cardStyles.screenColor,
          }}
        >
          <div className={styles.bodySettings}>
            <div className={styles.laneV2Container}>
              <CardLaneV2 player={playersPreview[0]} theme={cardStyles} />
              <CardLaneV2 player={playersPreview[1]} theme={cardStyles} />
              {showCompactVersion && (
                <div style={{ marginTop: 36 }}>
                  <CardCompacted
                    players={compactCardPlayers}
                    theme={cardStyles}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScorecardSettingsV2;
